(function(angular){
	'use strict';

	angular
		.module('premiumWelcomeModule')
		.controller('PremiumWelcome', [
			'$timeout',
			PremiumWelcomeFunction
		]);

	function PremiumWelcomeFunction(
		$timeout) {

		var premiumWelcome = this;
		premiumWelcome.showText = false;

		premiumWelcome.$onInit = function() {
			$timeout(function() {
				premiumWelcome.showText = true;
			}, 2000);
		};
	}
})(window.angular);